import React from 'react';
import { Paper, Typography, Skeleton, Box } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { formatMoney } from '../../../utils/currency';

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const item = payload[0]?.payload;

  return (
    <Box p={1} bgcolor="white" boxShadow={2} borderRadius={1}>
      <Typography variant="subtitle2">{item.name}</Typography>
      <Typography variant="body2" fontWeight="bold">
        💰 Total: {formatMoney(item.value)}
      </Typography>
    </Box>
  );
};

const BranchSalesChart = ({ data = [], loading, branches = [] }) => {
  const branchesMap = Object.fromEntries(branches.map((b) => [b.id, b]));

  const chartData = data.map((item) => {
    const branch = branchesMap[item.branchId];
    return {
      ...item,
      name: branch ? (branch.deleted ? `${branch.name} (eliminada)` : branch.name) : `Sucursal ${item.branchId}`,
      deleted: !!branch?.deleted,
      color: branch?.color || '#90caf9',
    };
  });

  return (
    <Paper elevation={2} sx={{ p: 2, height: 360 }}>
      <Typography variant="subtitle1" gutterBottom>
        Ventas acumuladas
      </Typography>
      <Box sx={{ width: '100%', height: 300 }}>
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={300} />
        ) : chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} margin={{ top: 20, right: 20, bottom: 0, left: 0 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="value">
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.color}
                    fillOpacity={entry.deleted ? 0.4 : 1}
                    stroke={entry.deleted ? entry.color : undefined}
                    strokeDasharray={entry.deleted ? '4 3' : undefined}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="textSecondary">
              No hay datos disponibles.
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default BranchSalesChart;
